import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import VM from 'scratch-vm';
import { connect } from 'react-redux';

import ControlsComponent from '../components/controls/controls.jsx';
import { resetPortBusy, setPortBusy, setDeviceToast } from '../reducers/device.js';
import { showMessageAlertWithTimeout } from '../reducers/alerts'
import { setCurrentMode } from '../reducers/script.js';
import featureLibraryMap from '../utils/libraryMap.js';

class Controls extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isShow: false,
            popupTitle: '',
            popupMessage: '',
        };
        const params = new URLSearchParams(window.location.search);
        this.device = params.get('device') || null;
        this.version = params.get('version') || null;
        this.sendDataRef = React.createRef();
        this.dataSendTimeOutRef = React.createRef();
        this.checkOkAbortRef = React.createRef();
        this.sendDataRef.current = { sendDataAsPacket: false, readVal: '' };
        this.dataSendTimeOutRef.current = null;
        this.checkOkAbortRef.current = false;
        bindAll(this, [
            'handleGreenFlagClick',
            'handleStopAllClick',
            'handleUSBConnectClick',
            'handleConvPyClick',
            'messageHandler',
            'handelScriptChange',
        ]);
    }

    getDeviceName() {
        const urlParams = new URLSearchParams(window.location.search);
        const currentDevice = urlParams.get('device') || this.device;
        if (!currentDevice) return 'PeeCee';
        const map = {
            'roboki': 'Roboki',
            'toki': 'Toki',
            'poki': 'Poki',
            'moki': 'Moki',
            'peecee': 'PeeCee',
            'ace': 'PeeCee',
            'zingZeroPointOne': 'Zing 0.1',
            'zingOnePointZero': 'Zing 1.0',
            'zingTwoPointZero': 'Zing 2.0',
            'zingThreePointZero': 'Zing 3.0',
            'hexapod': 'Hexapod',
            'hexapodTwoPointZero': 'Hexapod 2.0',
            'onePointZero': '1.0',
            'RoboticArm': 'Robotic Arm'
        };
        if (map[currentDevice]) return map[currentDevice];
        return currentDevice.charAt(0).toUpperCase() + currentDevice.slice(1);
    }

    getProject = async() => {
        await new Promise(resolve => setTimeout(resolve, 2000));
        // get project data from zing microPython board
        const removeFileCommend = `import os\rprint(os.listdir())\r`;
        const asciRemoveFileCommend = [...removeFileCommend].map(char =>
            char.charCodeAt(0)
        );
        this.props.worker.postMessage({
            type: 'WriteArrayFormat1310',
            value: [3, ...asciRemoveFileCommend],
        });
        this.sendDataRef.current = { sendDataAsPacket: false, readVal: '' };

        const stringDataArr = await Promise.race([
            this.checkOk(),
            this.timeoutPromise(180000), //
        ]);

        // remove the boot.py
        stringDataArr.map((ele, i) => {
            if (ele === 'boot.py') {
                stringDataArr.splice(i, 1);
            }
        });

        const pythonFiles = stringDataArr.filter(f =>
            f.toLowerCase().endsWith('.py')
        );

        // delete the each file one by one
        for (let i = 0; i < pythonFiles.length; i++) {
            const removeFileCommend = `import os\ros.remove("${pythonFiles[i]}")\r`;
            const asciRemoveFileCommend = [...removeFileCommend].map(char =>
                char.charCodeAt(0)
            );
            this.props.worker.postMessage({
                type: 'ignoreConsolePrint',
                value: [3, ...asciRemoveFileCommend],
            });
            this.sendDataRef.current = { sendDataAsPacket: false, readVal: '' };
            await Promise.race([
                checkOk(),
                timeoutPromise(5000),
            ]);
        }

        console.log('getProject called function end');
    }

    // generate the write any code in microPython board to a spcific file
    generateFileWriteCode = (filename, code) => {
        const fileAsciCode = [];
        const t = filename;
        let c = code;
        c = c.replace(/"/g, "'"); // replace all double quots to single quots

        const openCode = `f = open("${t}", "wb")\nf.write("`;
        const endCode = `")\nf.close()\n`;

        const asciOpenCode = [...openCode].map(char => char.charCodeAt(0));
        const asciEndCode = [...endCode].map(char => char.charCodeAt(0));

        const asciCreatFileCode = [...c].map(char => char.charCodeAt(0));

        // replace all the new line to \\n like 10 change to 92 110
        const indices = [];
        for (let i = 0; i < asciCreatFileCode.length; i++) {
            if (asciCreatFileCode[i] === 10) {
                indices.push(i);
            }
        }
        for (let i = indices.length - 1; i >= 0; i--) {
            asciCreatFileCode.splice(indices[i], 1, 92, 110);
        }

        return [
            ...fileAsciCode,
            ...asciOpenCode,
            ...asciCreatFileCode,
            ...asciEndCode,
        ];
    }

    fileExplorerCode = async() => {
        let fileAsciCode = [];
        fileAsciCode = this.generateFileWriteCode('main.py', this.props.codes);

        const hardResetCode = `import machine\nmachine.reset()`;
        const asciHardResetCode = [...hardResetCode].map(char =>
            char.charCodeAt(0)
        );
        this.props.worker.postMessage({
            type: 'writeArray',
            value: [3],
        });
        await new Promise(resolve => setTimeout(resolve, 500));

        this.props.worker.postMessage({
            type: 'writeArray',
            value: [1, ...fileAsciCode, ...asciHardResetCode, 4, 2],
        });
        await new Promise(resolve => setTimeout(resolve, 2000));
    }

    writeUltrasonicLibrary = async() => {
        try {
            const lib = featureLibraryMap.microPython.ultrasonic;
            const response = await fetch(lib.link);
            if (!response.ok) {
                throw new Error(`Failed to fetch library !`);
            }

            const code = await response.text();
            const fileAsciCode = this.generateFileWriteCode(lib.filename, code);
            this.props.worker.postMessage({
                type: 'writeArray',
                value: [3],
            });
            await new Promise(resolve => setTimeout(resolve, 500));

            this.props.worker.postMessage({
                type: 'writeArray',
                value: [1, ...fileAsciCode, 4, 2],
            });
        } catch (e) {
            throw new Error(`Failed to upload library !`);
        }
    }

    // ─── Firmware detection helpers ────────────────────────────────────────────
    //
    // Both detectors work by sending Ctrl+C (byte 3) and listening for 2 s on
    // { type:'read' } worker messages (format1310 is OFF during writeArray).
    //
    // MicroPython firmware responds with the REPL prompt ">>>" after Ctrl+C.
    // Real-time firmware does NOT produce ">>>" – it either echoes differently
    // or stays silent.
    //
    // detectMicroPythonFirmware() → true  if ">>>" seen  (MicroPython present)
    // detectRTFirmware()          → true  if ">>>" NOT seen (RT firmware present)

    _probeForREPL = () => new Promise(resolve => {
        let buffer = '';
        let settled = false;

        const finish = sawREPL => {
            if (settled) return;
            settled = true;
            this.props.worker.removeEventListener('message', tempHandler);
            clearTimeout(timer);
            resolve(sawREPL);
        };

        const tempHandler = e => {
            if (e.data.type !== 'read') return;
            const bytes = e.data.value
                .split(',')
                .filter(Boolean)
                .map(Number);
            const chunk = String.fromCharCode(...bytes);
            buffer += chunk;

            if (buffer.includes('>>>') || buffer.includes('raw REPL')) {
                finish(true);
            }
        };

        // 2-second window for the device to respond
        const timer = setTimeout(() => {
            finish(false);
        }, 2000);

        this.props.worker.addEventListener('message', tempHandler);
        // writeArray keeps format1310 = false so responses arrive as {type:'read'}
        this.props.worker.postMessage({ type: 'writeArray', value: [3] });
    })

    detectMicroPythonFirmware = () => this._probeForREPL()

    // Returns true if RT firmware is detected (Real-time mode check).
    // RT firmware is assumed when MicroPython is NOT detected.
    detectRTFirmware = async() => {
        const sawMicroPython = await this._probeForREPL();
        return !sawMicroPython;
    }

    // Probes for RT firmware by sending a minimal no-op RT packet via
    // WriteArrayFormat1310 and waiting for any readFormat1310 response.
    // MicroPython firmware does not speak this framing protocol → stays
    // silent → timeout → returns false.
    detectRTFirmwareViaPing = () => new Promise(resolve => {
        let settled = false;
        const finish = found => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            this.props.worker.removeEventListener('message', handler);
            console.log('[RT-PROBE] result:', found ? 'RT firmware CONFIRMED' : 'RT firmware NOT detected (timeout)');
            resolve(found);
        };

        const handler = e => {
            console.log('[RT-PROBE] worker msg | type:', e.data.type, '| value:', e.data.value);
            if (e.data.type === 'readFormat1310') {
                console.log('[RT-PROBE] readFormat1310 received → RT firmware confirmed');
                finish(true);
            }
        };

        const timer = setTimeout(() => {
            console.log('[RT-PROBE] 3s timeout — no readFormat1310 received');
            finish(false);
        }, 3000);

        this.props.worker.addEventListener('message', handler);

        // Minimal valid RT packet:
        //   RT511SET  = [82,84,53,49,49,83,69,84]  (8 byte header)
        //   settings  = 'O' x 59                   (all ports default, no peripherals)
        //   program   = o { } R S T                (empty loop, no side effects)
        const header      = [82, 84, 53, 49, 49, 83, 69, 84]
        const settingPort = new Array(59).fill(79)
        const emptyProg   = [111, 123, 125, 82, 83, 84]  // o { } R S T
        const pingPacket  = [...header, ...settingPort, ...emptyProg]

        console.log('[RT-PROBE] Sending ping | length:', pingPacket.length, '| bytes:', pingPacket.join(','))
        this.props.worker.postMessage({ type: 'WriteArrayFormat1310', value: pingPacket })
    })

    // Pulses DTR to reset the MCU, halting any program the device is currently
    // running so it returns to its idle RT command loop. Resolves when the
    // worker signals resetComplete (or after a safety timeout).
    resetDeviceViaDTR = () => {
        return new Promise((resolve) => {
            let settled = false
            const finish = () => {
                if (settled) return
                settled = true
                clearTimeout(timer)
                this.props.worker.removeEventListener('message', handler)
                resolve()
            }
            const handler = (e) => {
                if (e.data.type === 'resetComplete' || e.data.type === 'resetFailed') {
                    console.log('[RT-PROBE] device reset signalled:', e.data.type)
                    finish()
                }
            }
            // Worker's DTR pulse + boot wait is ~800ms; give it 2s headroom.
            const timer = setTimeout(() => {
                console.log('[RT-PROBE] reset wait timed out — proceeding anyway')
                finish()
            }, 2000)
            this.props.worker.addEventListener('message', handler)
            console.log('[RT-PROBE] probe failed — resetting device (DTR) before retry...')
            this.props.worker.postMessage({ type: 'resetDevice' })
        })
    }

    // ─── MicroPython (Update mode) upload ──────────────────────────────────────

    pythonProgramUpload = async() => {
        try {
            const libraryDependentFeatures = JSON.parse(
                sessionStorage.getItem('libraryDependentFeatures') || '[]'
            );

            // Step 1: Confirm MicroPython firmware is installed before sending
            // raw-REPL sequences. Sending those bytes to RT firmware corrupts
            // the device UART state and breaks subsequent Real-time uploads.
            this.setState({ isShow: true, popupMessage: 'Checking firmware...' });

            const hasMicroPython = await this.detectMicroPythonFirmware();

            if (!hasMicroPython) {
                this.setState({
                    popupMessage:
                        'Required firmware not found. Please install MicroPython firmware on the device.',
                });
                return;
            }

            // Step 2: Optional library upload
            if (libraryDependentFeatures?.includes('ultrasonic')) {
                this.setState({ isShow: true, popupMessage: 'Install library...' });
                await this.writeUltrasonicLibrary();
            }

            // Step 3: Upload main program
            this.setState({ isShow: true, popupMessage: 'Program uploading...' });
            await this.fileExplorerCode();

            this.setState({ popupMessage: 'Program upload successfully.' });
        } catch (e) {
            if (
                [
                    `Failed to fetch library !`,
                    `Failed to upload library !`,
                ].includes(e.message)
            ) {
                this.setState({ popupMessage: e.message });
            } else {
                this.setState({ popupMessage: 'Program upload failed !' });
            }
        } finally {
            this.props.setPortBusy({
                isPortBusy: false,
                portBusyFor: '',
                message: '',
            });
        }
    }

    // ─── Real-time (HEX) upload ────────────────────────────────────────────────

    async handleGreenFlagClick(e) {
        e.preventDefault();
        if (e.shiftKey) {
            this.props.vm.setTurboMode(!this.props.turbo);
            return;
        }

        // ── Update mode (MicroPython) ─────────────────────────────────────────
        if (this.props.currentMode.isCodingMode) {
            if (sessionStorage.getItem('usbConnectionStatus') == 'false') {
                this.props.showDeviceAlert(`No device connected. Plug in your ${this.getDeviceName()} and connect it before uploading.`, 'warn', 'deviceNotConnected')
                return
            }
            if (this.props.portBusy.isPortBusy) {
                this.props.showDeviceAlert(this.props.portBusy.message, 'info', 'portBusy')
                return
            }

            if (this.props.currentMode.isMicroPythonMode) {
                await this.pythonProgramUpload();
            }
            setTimeout(() => {
                this.setState({ isShow: false });
            }, 2500);
            return;
        }

        // ── Real-time mode (HEX payload) ──────────────────────────────────────
        if (sessionStorage.getItem('usbConnectionStatus') == 'false') {
            this.props.showDeviceAlert(`No device connected. Plug in your ${this.getDeviceName()} and connect it before uploading.`, 'warn', 'deviceNotConnected')
            return
        }
        if (this.props.portBusy.isPortBusy) {
            this.props.showDeviceAlert(this.props.portBusy.message, 'info', 'portBusy')
            return
        }

        // Step 0: Confirm RT firmware is present before uploading.
        // A running program (e.g. a forever loop from a previous upload) keeps
        // the device too busy to answer the probe, producing a false
        // "wrong firmware" result. So if the first probe fails, reset the device
        // (DTR) to halt any running program and probe once more before giving up.
        console.log('[RT-PROBE] Starting RT firmware detection...')
        let hasRTFirmware = await this.detectRTFirmwareViaPing()
        console.log('[RT-PROBE] hasRTFirmware (attempt 1):', hasRTFirmware)
        if (!hasRTFirmware) {
            console.log('[RT-PROBE] Retrying RT firmware detection after reset...')
            await this.resetDeviceViaDTR()
            hasRTFirmware = await this.detectRTFirmwareViaPing()
            console.log('[RT-PROBE] hasRTFirmware (after reset):', hasRTFirmware)
        }
        if (!hasRTFirmware) {
            this.props.showDeviceAlert(`This program needs the Real-time firmware. Please install it on your ${this.getDeviceName()} and try again.`, 'warn', 'wrongFirmware')
            return
        }
        // Brief pause so the device finishes the ping program before receiving the real payload.
        await new Promise(r => setTimeout(r, 500));

        // Step 1: Mark port busy and generate HEX payload
        this.props.setPortBusy({
            isPortBusy: true,
            portBusyFor: 'uploadProgram',
            message: 'Program is uploading please wait...',
        });
        if (!this.props.isStarted) {
            this.props.vm.start();
        }

        console.log(`[GreenFlag] device: ${this.device}`);

        let data;
        try {
            data = await this.props.vm.greenFlag();
        } catch (e) {
            console.error('[GreenFlag] byte generation threw:', e)
            this.props.setPortBusy({ isPortBusy: false, portBusyFor: '', message: '' })
            // Needs the user to go fix a block — give them longer to read it.
            this.props.showDeviceAlert('Couldn\'t build your program. Make sure every block field is filled in (e.g. the OLED text) and try again.', 'warn', 'genFailed', 15)
            return
        }

        // for byte generation time if any error came return not updates
        if (this.props?.vm.runtime?.Bisoft?._errorflag !== 0) {
            const bisoft = this.props.vm.runtime.Bisoft
            console.warn(
                '[GreenFlag] byte generation error, errorflag:',
                bisoft._errorflag,
                '| error_set:',
                [...bisoft._error_set]
            )
            this.props.setPortBusy({ isPortBusy: false, portBusyFor: '', message: '' })
            // Surface the compiler's validation errors as an in-app notification
            // (replaces the native alert previously shown from bisoft.js).
            const errorText = (typeof bisoft.showErrors === 'function' && bisoft.showErrors())
                ? bisoft.showErrors().trim()
                : 'Your program has an error. Please check the blocks and try again.'
            // Validation errors (bad sensor value, too-complex condition, …) —
            // the user must find and fix a block, so keep it up longer.
            this.props.showDeviceAlert(errorText, 'warn', 'codegenError', 15)
            return
        }

        if (!data) {
            console.warn('[GreenFlag] no data generated — missing green flag event block')
            this.props.setPortBusy({ isPortBusy: false, portBusyFor: '', message: '' })
            this.props.showDeviceAlert(
                'Add a \'when 🚩 clicked\' block to start your program.', 'info', 'noFlag'
            )
            return
        }

        // Step 3: Send payload and wait for device "OK"
        // On timeout: trigger a DTR-based MCU reset (same circuit as Arduino auto-reset)
        // and retry once before giving up.
        const sendAndWaitForOK = async payload => {
            this.props.worker.postMessage({ type: 'WriteArrayFormat1310', value: payload });
            this.sendDataRef.current = { sendDataAsPacket: false, readVal: '' };
            this.checkOkAbortRef.current = false;
            let timeoutHandle;
            const timeoutP = new Promise((_, reject) => {
                timeoutHandle = setTimeout(() => {
                    this.checkOkAbortRef.current = true;
                    reject(new Error('Timeout exceeded'));
                }, 5000);
            });
            try {
                const result = await Promise.race([this.checkOk(), timeoutP]);
                clearTimeout(timeoutHandle);
                return result;
            } catch (e) {
                clearTimeout(timeoutHandle);
                throw e;
            }
        };

        let replyOK = '';
        try {
            replyOK = await sendAndWaitForOK(data);
            console.log('[GreenFlag] device reply:', replyOK);
        } catch (e) {
            console.error('[GreenFlag] upload timed out / failed, resetting device and retrying:', e);
            this.props.worker.postMessage({ type: 'resetDevice' });
            await new Promise(r => setTimeout(r, 800)); // wait for MCU to reboot
            try {
                replyOK = await sendAndWaitForOK(data);
                console.log('[GreenFlag] device reply after retry:', replyOK);
            } catch (e2) {
                console.error('[GreenFlag] upload retry timed out / failed:', e2)
                this.props.showDeviceAlert(`Upload failed. Try reinstalling the Real-time firmware on your ${this.getDeviceName()}.`, 'warn', 'uploadFailed')
            }
        }

        // Step 4: Handle OK → send REST or AI enable bytes
        let statusAisOk = '';
        let statusAirOk = '';
        if (replyOK === 'OK') {
            if (this.props.vm.runtime.Bisoft._ai1Flag) {
                const waitTime = 100;
                await new Promise(resolve => setTimeout(resolve, waitTime));

                const crc = this.props.vm.runtime.Bisoft.crc_create(
                    [
                        ...this.props.vm.runtime.Bisoft._ai1PortEnableBytes,
                    ].splice(2, 8)
                );
                this.props.vm.runtime.Bisoft._ai1PortEnableBytes[10] = crc;

                this.props.worker.postMessage({
                    type: 'WriteArrayFormat1310',
                    value: this.props.vm.runtime.Bisoft._ai1PortEnableBytes,
                });
                this.sendDataRef.current = { sendDataAsPacket: false, readVal: '' };

                try {
                    statusAisOk = await Promise.race([
                        this.checkOk(),
                        this.timeoutPromise(5000),
                    ]);
                    console.log(
                        '[GreenFlag] AI enable (S) reply:',
                        statusAisOk
                    );
                } catch (e) {
                    this.props.showDeviceAlert('Upload failed. Check the connection and try again.', 'warn', 'uploadFailed')
                }
            } else {
                let waitTime = 100;
                if (this.device === 'roboki') {
                    waitTime = 600;
                }
                await new Promise((resolve) => setTimeout(resolve, waitTime))
                this.props.worker.postMessage({ type: 'write', value: 'REST' })
                this.props.showDeviceAlert('Program uploaded successfully!', 'success', 'uploadSuccess')
            }
        }

        // Step 5: Send AI reset bytes
        if (statusAisOk === 'AISOK') {
            const waitTime = 100;
            await new Promise(resolve => setTimeout(resolve, waitTime));

            const aiResetByte = [
                'A'.charCodeAt(0),
                'I'.charCodeAt(0),
                2,
                'X'.charCodeAt(0),
            ];
            const crc = this.props.vm.runtime.Bisoft.crc_create([
                2,
                'X'.charCodeAt(0),
            ]);
            aiResetByte.push(crc, 0xff, 0xf9);

            this.sendDataRef.current = { sendDataAsPacket: false, readVal: '' };
            this.props.worker.postMessage({
                type: 'WriteArrayFormat1310',
                value: aiResetByte,
            });

            try {
                statusAirOk = await Promise.race([
                    this.checkOk(),
                    this.timeoutPromise(5000),
                ]);
                console.log('[GreenFlag] AI reset (X) reply:', statusAirOk);
            } catch (e) {
                this.props.showDeviceAlert('Upload failed. Check the connection and try again.', 'warn', 'uploadFailed')
            }
        }

        if (statusAirOk === 'AIROK') {
            let waitTime = 100
            await new Promise((resolve) => setTimeout(resolve, waitTime))
            this.props.worker.postMessage({ type: 'write', value: 'REST' })
            this.props.showDeviceAlert('Program uploaded successfully!', 'success', 'uploadSuccess')
        }

        this.props.resetPortBusy();
    }

    handleStopAllClick(e) {
        e.preventDefault();
        this.props.vm.stopAll();
    }
    handleUSBConnectClick(e) {
        e.preventDefault();
        console.log('gui ok');
        this.props.vm.USBConnect();
    }
    handleConvPyClick(e) {
        e.preventDefault();
        this.props.vm.ConvPy();
    }

    timeoutPromise = ms => new Promise((resolve, reject) => {
        setTimeout(() => {
            this.checkOkAbortRef.current = true;
            reject(new Error('Timeout exceeded'));
        }, ms);
    })

    checkOk = async() => {
        this.checkOkAbortRef.current = false;
        return new Promise(async resolve => {
            while (!this.checkOkAbortRef.current) {
                const sendData_read = this.sendDataRef.current;
                if (sendData_read && sendData_read.sendDataAsPacket) {
                    return resolve(sendData_read.readVal);
                }
                await new Promise(r => setTimeout(r, 100));
            }
        });
    }

    componentDidMount = async() => {
        this.props.worker.addEventListener('message', this.messageHandler);
    }

    componentWillUnmount() {
        this.props.worker.removeEventListener('message', this.messageHandler);
    }

    // read data from serial worker
    messageHandler = e => {
        if (e.data.type === 'readFormat1310') {
            if (e.data.value === '79,75' || e.data.value?.includes('79,75')) {
                this.sendDataRef.current = { sendDataAsPacket: true, readVal: 'OK' };
            }
            if (e.data.value === '65,73,3,83,1,137,255,245') {
                this.sendDataRef.current = { sendDataAsPacket: true, readVal: 'AISOK' };
            }
            if (e.data.value === '65,73,3,88,1,30,255,245') {
                this.sendDataRef.current = { sendDataAsPacket: true, readVal: 'AIROK' };
            }
        }
        // 'read' messages are handled by the Console component and the inline
        // tempHandler inside _probeForREPL — no action needed here.
    }

    handelScriptChange() {
        this.props.setCurrentMode({
            ...this.props.currentMode,
            isMicroPythonMode: !this.props.currentMode.isMicroPythonMode,
        });
    }

    handelClosePopup() {
        this.setState({ isShow: false });
    }

    render() {
        const {
            vm, // eslint-disable-line no-unused-vars
            isStarted, // eslint-disable-line no-unused-vars
            projectRunning,
            turbo,
            ...props
        } = this.props;
        return (
            <ControlsComponent
                {...props}
                active={projectRunning}
                turbo={turbo}
                onGreenFlagClick={this.handleGreenFlagClick}
                onUSBConnectClick={this.handleUSBConnectClick}
                onConvPyClick={this.handleConvPyClick}
                currentMode={this.props.currentMode}
                handelScriptChange={this.handelScriptChange}
                isShow={this.state.isShow}
                popupMessage={this.state.popupMessage}
                popupTitle={this.state.popupTitle}
                handelClosePopup={this.handelClosePopup}
            />
        );
    }
}

Controls.propTypes = {
    isStarted: PropTypes.bool.isRequired,
    projectRunning: PropTypes.bool.isRequired,
    turbo: PropTypes.bool.isRequired,
    vm: PropTypes.instanceOf(VM),
    handelConsoleClear: PropTypes.func,
    showDeviceAlert: PropTypes.func,
}

const mapStateToProps = state => ({
    isStarted: state.scratchGui.vmStatus.running,
    projectRunning: state.scratchGui.vmStatus.running,
    turbo: state.scratchGui.vmStatus.turbo,
    worker: state.scratchGui.worker,
    portBusy: state.scratchGui.device.portBusy,
    currentMode: state.scratchGui.script.currentMode,
    codes: state.scratchGui.script.codes,
});
// no-op function to prevent dispatch prop being passed to component
const mapDispatchToProps = dispatch => ({
    setPortBusy: portBusyData => dispatch(setPortBusy(portBusyData)),
    resetPortBusy: () => dispatch(resetPortBusy()),
    setDeviceToast: (kind, message) => dispatch(setDeviceToast(kind, message)),
    setCurrentMode: data => dispatch(setCurrentMode(data)),
    // Show an in-app notification bar instead of a blocking native alert().
    // timeoutSecs is optional — omit it to use the per-level default.
    showDeviceAlert: (message, level, id, timeoutSecs) =>
        showMessageAlertWithTimeout(dispatch, { message, level, id, timeoutSecs }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Controls);
